import React from "react";
import './about.css'
import  {FireTable} from "../../components/Tables/FireTable";

export class About extends React.Component {


    render() {

        document.title = "Kansas Flint Hills Smoke Management - About";

        return (
            <div className={"about"}>

                <div className={'about-subtitle'}>
                    {this.props.i18n.About_Welcome_Title}
                </div>

                <div className={'about-paragraph'}>
                    {this.props.i18n.About_Welcome_P1}
                </div>

                <div className={'about-subtitle'}>
                    {this.props.i18n.About_Cumulative_Title}
                </div>

                <div className={'about-paragraph'}>
                    {this.props.i18n.About_Cumulative_P1}
                </div>

                <FireTable i18n={this.props.i18n}/>

                <div className={'about-subtitle'}>
                    {this.props.i18n.About_Impacts_Title}
                </div>

                <div className={'about-paragraph'}>
                    {this.props.i18n.About_Impacts_P1}
                </div>

                <div className={'about-subtitle'}>
                    {this.props.i18n.About_Forecast_Title}
                </div>

                <div className={'about-paragraph'}>
                    {this.props.i18n.About_Forecast_P1}
                </div>

                <div className={'about-attribution'}>
                </div>

            </div>
        )
    }

}

